var exports = {
  "DD": "xe533113f--f76361--title",
  "pb": "xe533113f--f76361--filter",
  "iE": "xe533113f--f76361--wrapper",
  "E1": "xe533113f--f76361--scrollable",
};

module.exports = exports;
